import { useState } from 'react';
import Header from './layout/Header';
import Left from './layout/Left';
import Content from './layout/Content';

const Layout = ({ children }) => {
  const [tab, setTab] = useState('items');

  const handleSetTab = (tab) => {
    setTab(tab);
  };

  return (
    <div className="flex flex-col h-screen w-screen">
      <Header tab={tab} onTabClick={handleSetTab} />
      {tab === 'items' && (
        <div className="flex flex-row h-screen">
          <Left />
          <Content>{children}</Content>
        </div>
      )}
      {/* <Footer /> */}
    </div>
  );
};

export default Layout;